"use client";

/**
 * Purpose: Client-side composition of the homepage sections (hero through
 * final quiz CTA), each wrapped in a scroll-triggered reveal.
 * Inputs: none.
 * Outputs: JSX.
 */

import "./home.css";
import { ScrollSection } from "@components/sections/ScrollSection/ScrollSection";
import { useLocale } from "next-intl";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import HomeHero from "@components/homehero/HomeHero/HomeHero";
import HomeTrustBar from "@components/bars/HomeTrustBar/HomeTrustBar";
import HomeAbout from "@components/homeabout/HomeAbout/HomeAbout";
import HomeAuthority from "@components/homeauthority/HomeAuthority/HomeAuthority";
import HomeHowItWorks from "@components/homehowitworks/HomeHowItWorks/HomeHowItWorks";
import HomeMethodology from "@components/homemethodology/HomeMethodology/HomeMethodology";
import HomeManifesto from "@components/homemanifesto/HomeManifesto/HomeManifesto";
import HomeQuizCta from "@components/homequizcta/HomeQuizCta/HomeQuizCta";

export default function HomeClient() {
  const locale = useLocale();
  const router = useRouter();
  const goToSurvey = () => router.push(`/${locale}/survey`);

  // Warm the survey route since it's the primary CTA target from several sections below.
  useEffect(() => {
    router.prefetch(`/${locale}/survey`);
  }, [router, locale]);

  return (
    // Sections below alternate ScrollSection reveal wrapping with static ones
    // (hero, trust bar, manifesto) that don't need the scroll-in treatment.
    <>
      <HomeHero onTakeQuiz={goToSurvey} />

      <HomeTrustBar />

      <ScrollSection>
        <HomeAbout />
      </ScrollSection>

      <ScrollSection>
        <HomeAuthority />
      </ScrollSection>

      <ScrollSection>
        <HomeHowItWorks onTakeQuiz={goToSurvey} />
      </ScrollSection>

      <ScrollSection>
        <HomeMethodology />
      </ScrollSection>

      <HomeManifesto />

      {/* Final CTA — no beta join option, just the quiz */}
      <ScrollSection>
        <HomeQuizCta onTakeQuiz={goToSurvey} />
      </ScrollSection>
    </>
  );
}
